
















import { Component, Vue } from 'vue-property-decorator';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

// ответ пользователя: сохранил и продолжает / продолжает без сохранения / остаётся (крестик и Esc тоже) /
// нажал "Сохранить", но не сохранилось - остаётся, причину (тост или окно отклонённых строк) уже видит
export type tUnsavedChoice = 'saved' | 'discard' | 'cancel' | 'failed';

/**
 * task-eak-1076: окно "Есть несохранённые изменения" с тремя кнопками (msgBoxConfirm умеет только две).
 * Сохранение выполняется внутри окна: оно закрывается только после ответа saveFn.
 */
@Component({name: 'c-unsaved-changes-modal'})
export default class CBudgetUnsavedChangesModal extends Vue {
    private showModal = false;
    private saving = false; // идёт сохранение - кнопки заблокированы, закрыть окно нельзя

    private saveFn: (() => Promise<boolean>) | null = null;
    private choice: tUnsavedChoice = 'cancel';
    private promise: Promise<tUnsavedChoice> | null = null;
    private resolveFn: ((choice: tUnsavedChoice) => void) | null = null;

    /**
     * показать окно
     * @param saveFn сохранение; true - сохранено, false - не сохранено (причина уже показана пользователю)
     */
    public open(saveFn: () => Promise<boolean>): Promise<tUnsavedChoice> {
        // окно уже показано - отдаём тот же ответ
        if (this.promise) { return this.promise; }
        this.saveFn = saveFn;
        this.choice = 'cancel';
        this.saving = false;
        this.promise = new Promise<tUnsavedChoice>(resolve => { this.resolveFn = resolve; });
        this.showModal = true;
        return this.promise;
    }

    private async saveClk() {
        if (this.saving || !this.saveFn) { return; }
        this.saving = true;
        let saved = false;
        try {
            saved = await this.saveFn();
        } catch (error) {
            saved = false;
        } finally {
            this.saving = false;
        }
        // не сохранилось - остаёмся на месте, причина уже показана пользователю
        this.finish(saved ? 'saved' : 'failed');
    }

    private finish(choice: tUnsavedChoice) {
        if (this.saving) { return; }
        this.choice = choice;
        this.showModal = false;
    }

    // крестик и Esc во время сохранения гасим
    private onHide(bvEvent: any) {
        if (this.saving) { bvEvent.preventDefault(); }
    }

    // любое закрытие даёт ответ
    private onHidden() {
        const resolve = this.resolveFn;
        const choice = this.choice;
        this.promise = null;
        this.resolveFn = null;
        this.saveFn = null;
        if (resolve) { resolve(choice); }
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get allTitle() {
        const obj = {
            title: this.getBudgetText('budget-event.unsaved-changes.title'), // Предупреждение
            text: this.getBudgetText('budget-event.unsaved-changes.text'), // Есть несохраненные изменения. Сохранить их перед продолжением?
            cancel: this.getBudgetText('budget-event.unsaved-changes.cancel'), // Отменить
            discard: this.getBudgetText('budget-event.unsaved-changes.discard'), // Продолжить без сохранения
            save: this.getBudgetText('budget-event.unsaved-changes.save') // Сохранить и продолжить
        }
        return obj;
    }
}
